import React, { useState } from 'react';
import { useEffect } from 'react';

const ProductExplorer = () => {


  useEffect(() => {
    (function(d, w, c) {
      w.ChatraID = 'XsYGMCQ4ANZregsLE';
      var s = d.createElement('script');
      w[c] = w[c] || function() {
        (w[c].q = w[c].q || []).push(arguments);
      };
      s.async = true;
      s.src = 'https://call.chatra.io/chatra.js';
      if (d.head) d.head.appendChild(s);
    })(document, window, 'Chatra');
  }, []);

  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('name');

  // Product data
  const products = [
  {
    id: "aurora-end-suction",
    name: "Aurora End Suction",
    category: "aurora-products",
    price: "$3,148",
    priceNote: "Starting Price",
    image: "/images/auroraendsuction.png",
    badge: "Best Seller",
    description: "High-efficiency centrifugal pumps for commercial applications.",
    specifications: {
      flowRate: "Up to 5,000 GPM",
      head: "Up to 520 feet",
      material: "Cast Iron/Stainless Steel"
    }
  },
  {
    id: 2,
    name: "Aurora Single Stage Inline",
    category: "aurora-products",
    price: "$4,188",
    priceNote: "Starting Price",
    image: "/images/382B family.png.thumb.1280.1280.png",
    badge: "",
    description: "Single stage vertical inline pump for compact installations.",
    specifications: {
      flowRate: "100-1000 GPM",
      head: "75-250 feet",
      material: "Cast Iron/Bronze"
    }
  },
  {
    id: 3,
    name: "Aurora Split Case Pumps",
    category: "aurora-products",
    price: "$9,939",
    priceNote: "Starting Price",
    image: "/images/stage-split-casefull.png",
    badge: "",
    description: "Heavy-duty split case pumps for high-volume applications.",
    specifications: {
      flowRate: "500-5000 GPM",
      head: "100-400 feet",
      material: "Cast Iron/Ductile Iron"
    }
  },
  
  // FAIRBANKS NIJHUIS PRODUCTS
  {
    id: 4,
    name: "Fairbanks Nijhuis End Suction Pump",
    category: "nijhuis-products",
    price: "REQUEST QUOTE",
    priceNote: "",
    image: "/images/nijhuis-end-suction.png",
    badge: "",
    description: "Reliable end suction pumps for water treatment and industrial applications.",
    specifications: {
      flowRate: "25-800 GPM",
      head: "30-250 feet",
      material: "Cast Iron/Stainless Steel"
    }
  },
  {
    id: 5,
    name: "Fairbanks Nijhuis Propellor Pump",
    category: "nijhuis-products",
    price: "REQUEST QUOTE",
    priceNote: "",
    image: "/images/nijhuis-propellor-removebg-preview.png",
    badge: "",
    description: "High-capacity propeller pumps for water movement and flood control.",
    specifications: {
      flowRate: "1000-15000 GPM",
      head: "10-50 feet",
      material: "Cast Iron/Stainless Steel"
    }
  },
  
  // MYERS AND HYDROMATIC PRODUCTS
  {
    id: 6,
    name: "Myers and Hydromatic Jet Pumps",
    category: "myers-products",
    price: "REQUEST QUOTE",
    priceNote: "",
    image: "/images/JETPUMPS.png",
    badge: "Popular",
    description: "Self-priming jet pumps for residential and light commercial water supply.",
    specifications: {
      flowRate: "5-50 GPM",
      head: "25-150 feet",
      material: "Cast Iron/Stainless Steel"
    }
  },
  {
    id: 7,
    name: "Myers and Hydromatic Centrifugal Pumps",
    category: "myers-products",
    price: "REQUEST QUOTE",
    priceNote: "",
    image: "/images/centrifugal-pumps.png",
    badge: "",
    description: "Heavy-duty centrifugal pumps for municipal and industrial applications.",
    specifications: {
      flowRate: "100-2000 GPM",
      head: "50-300 feet",
      material: "Cast Iron/Ductile Iron"
    }
  }
];

  const categories = {
    all: "All Products",
    "aurora-products": "Aurora Pumps",
    "nijhuis-products": "Fairbanks Nijhuis Pumps",
    "myers-products": "Myers & Hydromatics Pumps"
  };

  // Filter and sort products
  const filteredProducts = products
    .filter(product => 
      (selectedCategory === 'all' || product.category === selectedCategory) &&
      (product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
       product.description.toLowerCase().includes(searchTerm.toLowerCase()))
    )
    .sort((a, b) => {
      switch (sortBy) {
        case 'name':
          return a.name.localeCompare(b.name);
        case 'price':
          const priceA = parseFloat(a.price.replace(/[^0-9.-]+/g, "")) || 0;
          const priceB = parseFloat(b.price.replace(/[^0-9.-]+/g, "")) || 0;
          return priceA - priceB;
        case 'category':
          return a.category.localeCompare(b.category);
        default:
          return 0;
      }
    });

  return (
    <div className="explorer-page">
      {/* Breadcrumb */}
      <div className="explorer-breadcrumb-container">
        <nav className="explorer-breadcrumb">
          <a href="/" className="explorer-breadcrumb-link">Home</a>
          <span className="explorer-breadcrumb-separator"> › </span>
          <span className="explorer-breadcrumb-current">Products</span>
        </nav>
      </div>

      <div className="explorer-container">
        {/* Page Header */}
        <div className="explorer-header">
          <h1 className="explorer-title">Product Explorer</h1>
          <p className="explorer-subtitle">
            Discover our complete range of pumping solutions for every application
          </p>
        </div>

        {/* Filters and Search */}
        <div className="explorer-controls">
          <div className="explorer-search">
            <input
              type="text"
              placeholder="Search products..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="explorer-search-input"
            />
          </div>

          <div className="explorer-filters">
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="explorer-sort-select"
            >
              <option value="name">Sort by Name</option>
              <option value="price">Sort by Price</option>
              <option value="category">Sort by Category</option>
            </select>
          </div>
        </div>

        <div className="explorer-layout">
          {/* Left Sidebar - Categories */}
          <div className="explorer-sidebar">
            <h3 className="explorer-sidebar-title">Categories</h3>
            <ul className="explorer-category-list">
              {Object.entries(categories).map(([key, label]) => (
                <li key={key}>
                  <button 
                    className={`explorer-category-item ${selectedCategory === key ? 'active' : ''}`}
                    onClick={() => setSelectedCategory(key)}
                  >
                    {label}
                    <span className="explorer-category-count">
                      ({key === 'all' ? products.length : products.filter(p => p.category === key).length})
                    </span>
                  </button>
                </li>
              ))}
            </ul>

            <div className="explorer-sidebar-links">
              <a href="/contact" className="explorer-sidebar-link">Request Quote</a>
              <a href="/contact" className="explorer-sidebar-link">Contact Expert</a>
            </div>
          </div>

          {/* Right Content - Product Grid */}
          <div className="explorer-content">
            <div className="explorer-results-header">
              <h2 className="explorer-results-title">
                {categories[selectedCategory]} 
                <span className="explorer-results-count">({filteredProducts.length} products)</span>
              </h2>
            </div>
            
            <div className="explorer-products-grid">
              {filteredProducts.map((product) => (
                <div key={product.id} className="explorer-product-item">
                  {product.badge && (
                    <span className={`explorer-product-badge ${product.badge.toLowerCase().replace(' ', '-')}`}>
                      {product.badge}
                    </span>
                  )}
                  
                  <div className="explorer-product-image-container">
                    <img 
                      src={product.image} 
                      alt={product.name}
                      className="explorer-product-image"
                    />
                  </div>
                  
                  <div className="explorer-product-info">
                    <div className="explorer-product-category">
                      {categories[product.category]}
                    </div>
                    <h3 className="explorer-product-title">{product.name}</h3>
                    <p className="explorer-product-description">{product.description}</p>
                    
                    <div className="explorer-product-specs">
                      <div className="explorer-spec-item">
                        <span className="explorer-spec-label">Flow Rate:</span>
                        <span className="explorer-spec-value">{product.specifications.flowRate}</span>
                      </div>
                      {product.specifications.head && (
                        <div className="explorer-spec-item">
                          <span className="explorer-spec-label">Head:</span>
                          <span className="explorer-spec-value">{product.specifications.head}</span>
                        </div>
                      )}
                      {product.specifications.pressure && (
                        <div className="explorer-spec-item">
                          <span className="explorer-spec-label">Pressure:</span>
                          <span className="explorer-spec-value">{product.specifications.pressure}</span>
                        </div>
                      )}
                    </div>

                    <div className="explorer-product-pricing">
                      {product.priceNote && (
                        <div className="explorer-price-note">{product.priceNote}</div>
                      )}
                      <div className="explorer-product-price">{product.price}</div>
                    </div>

                    <div className="explorer-product-actions">
                      <a href={`/products/${product.id}`} className="explorer-btn-primary">
                        View Details
                      </a>
                      <a href="/quote" className="explorer-btn-secondary">
                        Get Quote
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {filteredProducts.length === 0 && (
              <div className="explorer-no-results">
                <h3>No products found</h3>
                <p>Try adjusting your search criteria or browse all products.</p>
                <button 
                  onClick={() => {setSearchTerm(''); setSelectedCategory('all');}}
                  className="explorer-btn-primary"
                >
                  View All Products
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <style jsx>{`
        .explorer-page {
          background: white;
          min-height: 100vh;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        /* Breadcrumb */
        .explorer-breadcrumb-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 1rem 2rem 0 2rem;
        }

        .explorer-breadcrumb {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.9rem;
          margin-bottom: 1rem;
        }

        .explorer-breadcrumb-link {
          color: #6b7280;
          text-decoration: none;
          font-weight: 500;
          transition: color 0.2s ease;
        }

        .explorer-breadcrumb-link:hover {
          color: #09244f;
          text-decoration: underline;
        }

        .explorer-breadcrumb-current {
          color: #09244f;
          font-weight: 600;
        }

        .explorer-breadcrumb-separator {
          color: #d1d5db;
        }

        /* Main Container */
        .explorer-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 2rem 2rem 2rem;
        }

        /* Header */
        .explorer-header {
          text-align: center;
          margin-bottom: 3rem;
          padding-bottom: 2rem;
          border-bottom: 1px solid #e5e7eb;
        }

        .explorer-title {
          font-size: 2.5rem;
          font-weight: 700;
          color: #111827;
          margin: 0 0 1rem 0;
        }

        .explorer-subtitle {
          font-size: 1.1rem;
          color: #6b7280;
          margin: 0;
          max-width: 600px;
          margin-left: auto;
          margin-right: auto;
        }

        /* Controls */
        .explorer-controls {
          display: flex;
          gap: 1rem;
          margin-bottom: 2rem;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
        }

        .explorer-search {
          flex: 1;
          max-width: 400px;
        }

        .explorer-search-input {
          width: 100%;
          padding: 0.75rem 1rem;
          border: 1px solid #d1d5db;
          border-radius: 8px;
          font-size: 1rem;
          transition: border-color 0.2s ease;
        }

        .explorer-search-input:focus {
          outline: none;
          border-color: #09244f;
          box-shadow: 0 0 0 3px rgba(9, 36, 79, 0.1);
        }

        .explorer-filters {
          display: flex;
          gap: 1rem;
        }

        .explorer-sort-select {
          padding: 0.75rem 1rem;
          border: 1px solid #d1d5db;
          border-radius: 8px;
          font-size: 0.9rem;
          background: white;
          cursor: pointer;
          transition: border-color 0.2s ease;
        }

        .explorer-sort-select:focus {
          outline: none;
          border-color: #09244f;
        }

        /* Layout */
        .explorer-layout {
          display: grid;
          grid-template-columns: 280px 1fr;
          gap: 3rem;
        }

        /* Sidebar */
        .explorer-sidebar {
          background: #f8fafc;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          padding: 2rem 0;
          height: fit-content;
          position: sticky;
          top: 2rem;
        }

        .explorer-sidebar-title {
          font-size: 1.125rem;
          font-weight: 600;
          color: #374151;
          margin-bottom: 1.5rem;
          padding: 0 2rem;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .explorer-category-list {
          list-style: none;
          margin: 0;
          padding: 0;
        }

        .explorer-category-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          padding: 1rem 2rem;
          background: none;
          border: none;
          text-align: left;
          font-size: 1rem;
          font-weight: 500;
          color: #374151;
          cursor: pointer;
          transition: all 0.2s ease;
          border-left: 3px solid transparent;
        }

        .explorer-category-item:hover {
          background: #e5e7eb;
          color: #111827;
        }

        .explorer-category-item.active {
          background: #ffffff;
          color: #09244f;
          border-left-color: #09244f;
          font-weight: 600;
        }

        .explorer-category-count {
          font-size: 0.8rem;
          color: #9ca3af;
          font-weight: 400;
        }

        .explorer-category-item.active .explorer-category-count {
          color: #09244f;
        }

        .explorer-sidebar-links {
          margin-top: 2rem;
          padding: 0 2rem;
          border-top: 1px solid #e5e7eb;
          padding-top: 2rem;
        }

        .explorer-sidebar-link {
          display: block;
          color: #09244f;
          text-decoration: none;
          font-size: 0.9rem;
          font-weight: 500;
          padding: 0.5rem 0;
          transition: color 0.2s ease;
        }

        .explorer-sidebar-link:hover {
          color: #061a3d;
          text-decoration: underline;
        }

        /* Content Area */
        .explorer-content {
          background: white;
        }

        .explorer-results-header {
          margin-bottom: 2rem;
        }

        .explorer-results-title {
          font-size: 1.75rem;
          font-weight: 700;
          color: #111827;
          margin: 0;
        }

        .explorer-results-count {
          font-weight: 400;
          color: #6b7280;
          font-size: 1.25rem;
        }

        /* Products Grid */
        .explorer-products-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, 320px);
          gap: 2rem;
          justify-content: start;
        }

        .explorer-product-item {
          position: relative;
          background: white;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          overflow: hidden;
          transition: all 0.3s ease;
          display: flex;
          flex-direction: column;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
        }

        .explorer-product-item:hover {
          transform: translateY(-4px);
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          border-color: #09244f;
        }

        .explorer-product-badge {
          position: absolute;
          top: 1rem;
          right: 1rem;
          padding: 0.5rem 1rem;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.025em;
          z-index: 1;
        }

        .explorer-product-badge.best-seller {
          background: #dc2626;
          color: white;
        }

        .explorer-product-badge.ul-listed {
          background: #0891b2;
          color: white;
        }

        .explorer-product-badge.new {
          background: #059669;
          color: white;
        }

        .explorer-product-badge.popular {
          background: #7c3aed;
          color: white;
        }

        .explorer-product-image-container {
          aspect-ratio: 4/3;
          overflow: hidden;
          background: #f3f4f6;
          border-bottom: 1px solid #e5e7eb;
        }

        .explorer-product-image {
          width: 100%;
          height: 100%;
          object-fit: contain; 
          object-position: center;
          background: white; 
          padding: 1rem;
          box-sizing: border-box; 
          transition: transform 0.3s ease;
        }
        .explorer-product-item:hover .explorer-product-image {
          transform: scale(1.05);
        }

        .explorer-product-info {
          padding: 1.5rem;
          flex: 1;
          display: flex;
          flex-direction: column;
        }

        .explorer-product-category {
          font-size: 0.8rem;
          color: #0891b2;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin-bottom: 0.5rem;
        }

        .explorer-product-title {
          font-size: 1.25rem;
          font-weight: 600;
          color: #111827;
          margin: 0 0 0.75rem 0;
          line-height: 1.3;
        }

        .explorer-product-description {
          color: #6b7280;
          margin-bottom: 1rem;
          line-height: 1.5;
          font-size: 0.9rem;
        }

        .explorer-product-specs {
          background: #f9fafb;
          border-radius: 6px;
          padding: 1rem;
          margin-bottom: 1rem;
        }

        .explorer-spec-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0.5rem;
          font-size: 0.85rem;
        }

        .explorer-spec-item:last-child {
          margin-bottom: 0;
        }

        .explorer-spec-label {
          font-weight: 500;
          color: #374151;
        }

        .explorer-spec-value {
          font-weight: 600;
          color: #111827;
        }

        .explorer-product-pricing {
          margin-bottom: 1.5rem;
        }

        .explorer-price-note {
          font-size: 0.75rem;
          color: #6b7280;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin-bottom: 0.25rem;
        }

        .explorer-product-price {
          font-size: 1.25rem;
          font-weight: 700;
          color: #09244f;
        }

        .explorer-product-actions {
          display: flex;
          gap: 0.75rem;
          margin-top: auto;
        }

        .explorer-btn-primary, .explorer-btn-secondary {
          flex: 1;
          padding: 0.75rem 1rem;
          border-radius: 6px;
          text-decoration: none;
          font-weight: 600;
          font-size: 0.875rem;
          text-align: center;
          transition: all 0.2s ease;
          border: 2px solid transparent;
        }

        .explorer-btn-primary {
          background: #09244f;
          color: white;
          border-color: #09244f;
        }

        .explorer-btn-primary:hover {
          background: #061a3d;
          border-color: #061a3d;
          transform: translateY(-1px);
        }

        .explorer-btn-secondary {
          background: transparent;
          color: #09244f;
          border-color: #09244f;
        }

        .explorer-btn-secondary:hover {
          background: #09244f;
          color: white;
          transform: translateY(-1px);
        }

        /* No Results */
        .explorer-no-results {
          text-align: center;
          padding: 4rem 2rem;
          color: #6b7280;
        }

        .explorer-no-results h3 {
          font-size: 1.5rem;
          color: #111827;
          margin-bottom: 1rem;
        }

        .explorer-no-results p {
          margin-bottom: 2rem;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .explorer-layout {
            grid-template-columns: 1fr;
            gap: 2rem;
          }
          
          .explorer-sidebar {
            position: static;
            padding: 1.5rem 0;
          }
          
          .explorer-category-list {
            display: flex;
            overflow-x: auto;
            padding: 0 1rem;
            gap: 0.5rem;
          }
          
          .explorer-category-item {
            white-space: nowrap;
            padding: 0.75rem 1.5rem;
            border-radius: 25px;
            border-left: none;
            background: #e5e7eb;
            min-width: auto;
          }
          
          .explorer-category-item.active {
            background: #09244f;
            color: white;
          }
          
          .explorer-sidebar-links {
            display: none;
          }
          
          .explorer-products-grid {
            grid-template-columns: repeat(auto-fill, 280px);
            gap: 1.5rem;
            justify-content: center;
          }
        }

        @media (max-width: 768px) {
          .explorer-container {
            padding: 0 1rem 2rem 1rem;
          }
          
          .explorer-title {
            font-size: 2rem;
          }
          
          .explorer-controls {
            flex-direction: column;
            align-items: stretch;
          }
          
          .explorer-search {
            max-width: none;
          }
          
          .explorer-products-grid {
            grid-template-columns: 1fr;
          }
          
          .explorer-product-actions {
            flex-direction: column;
          }
        }
      `}</style>
    </div>
  );
};

export default ProductExplorer;